module.exports = __webpack_public_path__ + "img/buxzero-dark.30afe7fe.png";